import { Helmet } from 'react-helmet-async';
import PageHeader from '../Crypto/PageHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container } from '@mui/material';
import Footer from 'src/components/Footer';

import AccountBalance from '../Crypto/AccountBalance';
import Wallets from '../Crypto/Wallets';
import AccountSecurity from '../Crypto/AccountSecurity';
import WatchList from '../Crypto/WatchList';

function DashboardCrypto() {
  return (
    <>
      <Helmet>
        <title>Home Dashboard</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader DashTittle=" " subHeading=" " />
      </PageTitleWrapper>
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <AccountBalance />
          </Grid>
          <Grid item lg={8} xs={12}>
            <Wallets />
          </Grid>
          <Grid item lg={4} xs={12}>
            <AccountSecurity />
          </Grid>
          <Grid item xs={12}>
            <WatchList />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default DashboardCrypto;
